import api from "../api/config";

export const authService = {
  // Token alma fonksiyonu (GET olarak güncellendi)
  getToken: async (userName, password) => {
    try {
      console.log("AuthService: Token alınıyor (GET)...");
      // Parametreleri query string için hazırla
      const params = {
        userName, // Parametre adı API'nin beklediği ile aynı olmalı
        password,
      };
      // İstek GET olarak tam URL ile yapılıyor
      const response = await api.get("/getToken", { params });

      // Yanıt yapısını kontrol et (Varsayım: token doğrudan response içinde veya data içinde)
      if (response && response.token) {
        console.log("AuthService: Token alındı.");
        return response.token;
      } else if (response && response.data && response.data.token) {
        console.log("AuthService: Token alındı (data içinden).");
        return response.data.token;
      } else if (response && typeof response === "string") {
        // Belki token doğrudan string olarak dönüyor?
        console.log("AuthService: Token string olarak alındı.");
        return response;
      } else {
        console.error(
          "AuthService: Token yanıtı beklenmedik yapıda:",
          response
        );
        throw new Error("Token alınamadı veya yanıt yapısı hatalı.");
      }
    } catch (error) {
      console.error("AuthService Error getting token:", error);
      // Giriş denemesi başarısız olursa buradan da hata fırlatılabilir
      let errorMessage = "Token alınırken bir hata oluştu.";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      throw new Error(errorMessage);
    }
  },

  // Müşteri girişi
  login: async (phone, password) => {
    let userData = null;
    try {
      console.log("AuthService: Müşteri doğrulanıyor...");
      // Önce kullanıcıyı doğrula
      const authResponse = await api.post("/customers/authenticateCustomer", {
        phone,
        password,
      });

      // Kullanıcı doğrulama yanıtını kontrol et ({ status: 1, data: {...} } varsayımı)
      if (authResponse && authResponse.status === 1 && authResponse.data) {
        userData = authResponse.data;
        console.log("AuthService: Müşteri doğrulandı:", userData);
        localStorage.setItem("user", JSON.stringify(userData)); // Kullanıcı bilgisini kaydet
      } else {
        console.error(
          "AuthService: Müşteri doğrulama yanıtı beklenmedik yapıda:",
          authResponse
        );
        throw new Error(
          authResponse?.message || "Kullanıcı doğrulanamadı veya yanıt hatalı."
        );
      }

      // Kullanıcı doğrulandıysa token al
      const token = await authService.getToken(phone, password);
      localStorage.setItem("token", token); // Gerçek token'ı kaydet

      return userData; // Kullanıcı datasını döndür
    } catch (error) {
      // Hata durumunda kayıtlı bilgileri temizle (opsiyonel ama önerilir)
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      console.error("Login error (auth or token):", error);
      throw error; // Hatayı tekrar fırlat ki hook yakalasın
    }
  },

  // Müşteri kaydı
  register: async (userData) => {
    try {
      const response = await api.post("/customers/customerSignUp", userData);

      // Status 1 başarılı yanıt anlamına geliyor
      if (response.status === 1) {
        // console.log("Kayıt başarılı:", response.data);
        return response.data;
      }

      throw new Error(response.message || "Kayıt işlemi başarısız");
    } catch (error) {
      console.error("Register error:", error);
      if (error.response) {
        // API'den gelen hata
        throw new Error(
          error.response.data?.message || "Kayıt işlemi başarısız"
        );
      } else if (error.request) {
        // İstek yapıldı ama yanıt alınamadı
        throw new Error(
          "Sunucuya ulaşılamıyor. Lütfen internet bağlantınızı kontrol edin."
        );
      } else {
        // İstek oluşturulurken hata oluştu
        throw new Error(
          error.message || "Bir hata oluştu. Lütfen tekrar deneyin."
        );
      }
    }
  },

  // Çıkış yap
  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/"; // Ana sayfaya yönlendir
  },

  // Token kontrolü
  isAuthenticated: () => {
    const token = localStorage.getItem("token");
    const isAuth = !!token;
    // console.log(
    //   "Auth Service - isAuthenticated çağrıldı:",
    //   isAuth,
    //   "Token:",
    //   token
    // );
    return isAuth;
  },

  // Kullanıcı bilgilerini getir
  getCurrentUser: () => {
    const userStr = localStorage.getItem("user");
    return userStr ? JSON.parse(userStr) : null;
  },
};

export default authService;
